module.exports = __webpack_public_path__ + "img/MQ.37de241e.png";